import React, {useEffect, useState} from "react";
import styled, { withTheme } from "styled-components";
// import {motion} from 'framer-motion';
// Imported Components
import ExchangeTopGames from "./exchangepage-topgames/index";
import HomeExchange, { AppWrapper } from "../../home-exchange/index";
// import { Outlet } from "react-router-dom";
import { withAppContext } from "src/store/initAppContext";
import config from "src/config/config";
import { theme } from "styled-tools";
import { useLocation, useParams } from "react-router-dom";
import SEOContents from "src/components/SEOContents";
import { Helmet } from "react-helmet";
import { CRMPageVisit } from "src/util/crmUtil";
import getSchemaData from "src/components/schema";
import { getDamain } from "src/util/commonfun";
import { MetaProps, SEOFooterCommon, SEOMetaCommon } from "src/components/SEOMetaCommon";
import { sportsGamesSEOData } from "src/config/seo_api";

const structuredData = (brandId: any, domain: any, id: any) => {

  const _schemasportname: any = (brandId == 32 || brandId == 40 || brandId == 46) ? {
    'online-cricket-betting': 'Cricket Betting ID',
    'football-betting': 'Football Betting',
    'tennis-betting': 'Tennis Betting',
    'volleyball-betting': 'volleyball Betting ID'
  } : {
    'online-cricket-betting': 'Cricket Betting',
    'football-betting': 'Football Betting',
    'tennis-betting': 'Tennis Betting',
    'volleyball-betting': 'volleyball Betting'
  };

  // const schemaName: string = id ? id : 'betting-exchange';
  const schemaName: string = id || 'betting-exchange';
  const otherschemaData = getSchemaData(schemaName);

  let itemList = [
    {
      "@type": "ListItem",
      "item": `${domain}`,
      "name": "Homepage",
      "position": 1
    },
    {
      "@type": "ListItem",
      "item": `${domain}/betting-exchange/`,
      "name": "Exchange",
      "position": 2
    }
  ];
  if (id) {
    itemList = [...itemList, {
      "@type": "ListItem",
      "item": `${domain}/betting-exchange/${id}`,
      "name": `${_schemasportname[id]}`,
      "position": 3
    }]
  }

  const data = [
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": itemList,
      "name": "Breadcrumbs"
    },
    ...otherschemaData
  ];

  return JSON.stringify(data);
}

const ExchangePage = (props) => {
  const {
    app: { brandId },
    theme,
  } = props;

  const { id } = useParams();
  
  let domainURL = getDamain(brandId);
  const { config: {showAPISEOData}} = theme

  const [seoObjects, setseoObjects] = useState({} as MetaProps);
  const _location = useLocation();
  const pathName = _location.pathname;
  const getSeoData = sportsGamesSEOData();

  useEffect(()=> {
    //for CRM
    CRMPageVisit();
  },[])

   //for SEO
    useEffect(() => {
        if (showAPISEOData) {
            // const getSeoData = sportsGamesSEOData();
            // const pathName = _location.pathname;
            getSeoData.then(resp => {
                const { objects } = resp;
                const seoData = objects.find((obj: any) => {
                    const { metadata = {} } = obj;
                    if (metadata.pathname && metadata.pathname === pathName) {
                        return obj;
                    }

                }) || {};

                const { metadata = {} } = seoData;
                setseoObjects(metadata);

            }).catch(error => console.log(`[${pathName}]:Error in SEO API`))

        }
    }, [pathName]);

  return (
    <ExchangeWrapper>
       {showAPISEOData && (<SEOMetaCommon metaData={seoObjects} />)}

      {!showAPISEOData && (
        <Helmet>
        <script type="application/ld+json">
          {structuredData(brandId, domainURL, id)}

        </script>
      </Helmet>)
      }
      {!id && !showAPISEOData && (<>
          
          <SEOContents pageName={"sportsBetting"} />

        </>)
      }

      {!showAPISEOData && id && id==='online-cricket-betting' && 
      <>
        <SEOContents pageName={"onlineCricketSattaBazar"}/>
      </>
      }

      {!showAPISEOData && id && id==='football-betting' && 
      <>
        <SEOContents pageName={"footballBetting"}/>
      </>
      }

      {!showAPISEOData && id && id==='tennis-betting' && 
      <>
        <SEOContents pageName={"tennisBetting"}/>
      </>
      }

      {!showAPISEOData && id && id==='volleyball-betting' && 
      <>
        <SEOContents pageName={"volleyballBetting"}/>
      </>
      }
      




      
      <ExchangeTopGames />
      <HomeExchange />
      {/* <Outlet/> */}
     {showAPISEOData && <SEOFooterCommon footer_title={seoObjects['seo_footer_title_(h1)']} footer_content={seoObjects['seo_footer_content']} />}
    </ExchangeWrapper>
    // </motion.div>
     
  );
};

export default withTheme(withAppContext(ExchangePage));

/*! styled-components */
const ExchangeWrapper = styled.div`
  width: 100%;
  height: auto;
  background-image: url(${config.imageV3Host}/static/cashsite/${theme("image.homeExchangeBgImage")});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top right;
  background-attachment: fixed;

  ${AppWrapper} {
    min-height: 100vh;
  }
`;
